import { ILeadsReadonly } from '@llws/lift-entity-interfaces';
import { IQueryCommandOptions } from '@llws/dynamic-router-utils';
import { StoreBaseImplementationV2 } from '../../shared/classes/store-base-implementation-v2';

// Base store configuration
const adminGatewayResourcePath: string = '/leads-api/leads_readonly';
const listViewName: string = '';
const showLogging: boolean = false;

const defaultGetListFilters: IQueryCommandOptions = {
  relations: [
    {
      path: 'building',
      alias: 'building',
    },
    {
      path: 'building.city',
      alias: 'city',
    },
  ],
};
const defaultGetSingleFilters: IQueryCommandOptions = {};

// Instantiate the base store with the params
const base = new StoreBaseImplementationV2<ILeadsReadonly>({
  adminGatewayResourcePath,
  defaultGetSingleFilters,
  defaultGetListFilters,
  listViewName,
  showLogging,
});

// Extend StoreBaseImplementation object to add custom state/getters/mutations/actions.
export default {
  namespaced: base.namespaced, // 'leads_readonly/'

  state: {
    ...base.state,
  },

  getters: {
    ...base.getters,

  },

  mutations: {
    ...base.mutations,
  },

  actions: {
    ...base.actions,
  },
};
